<div
  class="flex flex-col sm:flex-row items-center justify-between gap-4 px-6 py-4 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">

  <!-- Info -->
  <div class="text-xs text-gray-500 dark:text-gray-400">
    Showing <span class="font-semibold">{{ startItem() }}</span> to <span class="font-semibold">{{ endItem() }}</span>
    of <span class="font-semibold">{{ total() }}</span> entries
  </div>

  <!-- Controls -->
  <div class="flex items-center gap-2">
    <!-- First -->
    <button (click)="onPageChange(1)" [disabled]="currentPage() === 1"
      class="hidden sm:inline-flex px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg text-xs font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
      First
    </button>

    <!-- Previous -->
    <button (click)="onPageChange(currentPage() - 1)" [disabled]="currentPage() === 1"
      class="px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg text-xs font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
      Previous
    </button>

    <!-- Page Numbers -->
    <div class="flex items-center gap-1">
      @for (page of visiblePages(); track page) {
      <button (click)="onPageChange(page)" [class]="'w-8 h-8 flex items-center justify-center rounded-lg text-xs font-medium transition-colors ' + 
                 (page === currentPage() 
                    ? 'bg-emerald-600 text-white shadow-sm shadow-emerald-200 dark:shadow-none ring-1 ring-emerald-600' 
                    : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700')">
        {{ page }}
      </button>
      }
    </div>

    <!-- Next -->
    <button (click)="onPageChange(currentPage() + 1)" [disabled]="currentPage() === totalPages()"
      class="px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg text-xs font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
      Next
    </button>

    <!-- Last -->
    <button (click)="onPageChange(totalPages())" [disabled]="currentPage() === totalPages()"
      class="hidden sm:inline-flex px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg text-xs font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
      Last
    </button>
  </div>
</div>